<template>
  <!-- DETAIL ENDPOINTU -->
  <div v-if="device" class="detail-page" @scroll="onScroll">
    <div v-if="device" :class="{ visible: isHeaderFixed }" class="detail-page__sticky-header d-flex align-items-center">
      <div class="detail-page__sticky-header__left d-flex">
        <strong class="detail-page__sticky-header__name">
          {{ $filters.strLimit(device.custDestName, 12) }}
        </strong>
        <div class="d-flex align-items-center ml-2">
          <div v-if="device.custDestEnabled == true" class="atom-state atom-state--success" />
          <div v-else class="atom-state atom-state--danger" />
          {{ device.custDestId }}
        </div>
      </div>
      <div class="detail-page__sticky-header__right d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-end detail-page__tabs__wrapper">
          <div :class="{ active: selectedTab == 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
            {{ $t("vseOBrane") }}
          </div>
          <!--div class="detail-page__tabs__tab" @click="selectedTab = 3" v-bind:class="{'active':(selectedTab == 3)}">{{ $t("logOperaci") }}</div-->
          <div :class="{ active: selectedTab == 4 }" class="detail-page__tabs__tab" @click="selectedTab = 4">
            {{ $t("routovaciSkupiny") }}
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-end detail-page__sticky-header__buttons">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditEndpointModal('editEndpoint')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteModal"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>
      </div>
    </div>
    <div v-if="device" id="detail-header" class="layout__content__header layout__content__header--white">
      <CopyNotification
        :opened="copyConfirmVisible"
        :text="'zkopirovanoDoSchranky'"
        @close="copyConfirmVisible = false"
      />

      <AppBack
        :route="{
          name: 'mqttEndpoints',
          params: {
            customerId,
            projectId
          }
        }"
        :text="'NA_SEZNAM_ENDPOINTU_MQTT'"
      />
      <div class="d-flex justify-content-between">
        <div class="d-flex flex-column flex-lg-row align-items-lg-center layout__content__header__title">
          <h1 class="mb-0 mw-100">
            {{ device.custDestName }}
          </h1>
          <span v-if="device" class="detail-page__info__item ml-lg-3 mb-3">
            <div v-if="device.custDestEnabled == true" class="atom-state atom-state--success" />
            <div v-else class="atom-state atom-state--danger" />
            {{ device.custDestId }}
          </span>
        </div>
        <div class="layout__content__header__buttons d-none d-md-flex align-items-end justify-content-end mb-3">
          <button
            class="btn btn-primary d-flex align-items-center justify-content-center"
            @click="toggleEditEndpointModal('editEndpoint')"
          >
            <div class="atom-icon">
              <img src="@/assets/icons/actions/ico-btn-edit.svg" />
            </div>
            {{ $t("upravit") }}
          </button>
          <button
            class="btn btn-outline-primary btn-icon d-flex align-items-center justify-content-center m-0"
            @click="toggleDeleteModal"
          >
            <div class="atom-icon m-0">
              <img src="@/assets/icons/actions/ico-ico-delete.svg" />
            </div>
          </button>
        </div>
      </div>

      <div class="detail-page__info d-flex align-items-center font-weight-light flex-wrap">
        <div class="w-100">
          <span v-if="device.custDestParameters" class="detail-page__info__item gray-text-light mb-1">
            <div v-tooltip :title="device.custDestParameters.address">
              {{ $filters.strLimitEnd(device.custDestParameters.address, 36) }}
            </div>
            <div
              v-if="device.custDestParameters.address"
              class="atom-copy d-flex align-items-center ml-2"
              @click="copyToClipboard(device.custDestParameters.address)"
            >
              <img src="@/assets/icons/actions/ico-ico-copy.svg" />
            </div>
          </span>
        </div>
        <span class="detail-page__info__item">MQTT</span>
        <span v-if="device.custDestDescription" class="detail-page__info__item gray-text-light">
          {{ device.custDestDescription }}
        </span>
      </div>
      <div v-if="device" class="detail-page__boxes d-flex flex-column flex-md-row pb-3">
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $t("aktivita") }}
          </p>
          <div v-if="lastMessage > 0" class="detail-page__boxes__value detail-page__boxes__textWithIcon">
            <img class="atom-icon--time" src="@/assets/icons/endpoint-activity/ico-last-time-active.svg" />
            <span v-if="lastMessage < 60">{{ $t("pred") }} {{ lastMessage }} s</span>
            <span v-else-if="lastMessage / 60 < 60">
              {{ $t("pred") }}
              {{ Math.round(lastMessage / 60) }} m
            </span>
            <span v-else-if="lastMessage / 60 / 60 < 24">
              {{ $t("pred") }}
              {{ Math.round(lastMessage / 60 / 60) }} h
            </span>
            <span v-else-if="lastMessage / 60 / 60 / 24 < 30">
              {{ $t("pred") }}
              {{ Math.round(lastMessage / 60 / 60 / 24) }} d
            </span>
            <span v-else>{{ $t("pred") }} > 30 d</span>
          </div>
          <div v-else-if="isGatewayLoading" class="detail-page__boxes__value">
            <div class="detail-page__boxes__textWithIcon">
              <img
                class="atom-icon--time atom-icon--muted"
                src="@/assets/icons/endpoint-activity/ico-last-time-active.svg"
              />
              <div class="small">?</div>
            </div>
          </div>
          <div v-else>
            <div class="detail-page__boxes__textWithIcon">
              <img
                class="atom-icon--time atom-icon--muted"
                src="@/assets/icons/endpoint-activity/ico-last-time-active.svg"
              />
              <div class="small" v-html="$t('zadnaAktivita')" />
            </div>
          </div>
        </div>
        <div class="detail-page__boxes__item battery">
          <p class="label font-weight-light">
            {{ $t("pocetZarizeni") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <div class="detail-page__boxes__textWithIcon">
              <img
                v-if="device.devices > 0"
                class="detail-page__boxes__textWithIcon__icon"
                src="@/assets/icons/endpoint-activity/ico-ico-zarizeni.svg"
              />
              <img
                v-else
                class="detail-page__boxes__textWithIcon__icon atom-icon--muted"
                src="@/assets/icons/endpoint-activity/ico-ico-zarizeni.svg"
              />
              {{ device.devices }}
            </div>
          </div>
        </div>
        <div class="detail-page__boxes__item">
          <p class="label font-weight-light">
            {{ $t("pocetSkupin") }}
          </p>
          <div class="detail-page__boxes__value d-flex align-items-center">
            <div class="detail-page__boxes__textWithIcon">
              <img
                v-if="device.deviceGroups.length > 0"
                class="detail-page__boxes__textWithIcon__icon"
                src="@/assets/icons/endpoint-activity/ico-ico-skupina.svg"
              />
              <img
                v-else
                class="detail-page__boxes__textWithIcon__icon atom-icon--muted"
                src="@/assets/icons/endpoint-activity/ico-ico-skupina.svg"
              />
              {{ device.deviceGroups.length }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedTab == 1">
        <RadioHelp
          :article-link="'/mqtt-endpoint/informace'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
      <!-- NAPOVEDA ROUTOVACI SKUPINY -->
      <div v-if="selectedTab == 2">
        <RadioHelp
          :article-link="'/mqtt-endpoint/skupiny'"
          :show="showHelp"
          @change-radio-btn-visibility="changeRadioBtnVisibility($event)"
          @update-show-radio-help="showRadioHelp($event)"
        />
      </div>
    </div>

    <div class="layout__content__content pt-0 px-0">
      <div id="tabs" class="detail-page__tabs">
        <div class="detail-page__tabs__header d-flex">
          <div class="d-flex align-items-end detail-page__tabs__wrapper">
            <div :class="{ active: selectedTab == 1 }" class="detail-page__tabs__tab" @click="selectedTab = 1">
              {{ $t("VSE_O_BRANE") }}
            </div>
            <div :class="{ active: selectedTab == 2 }" class="detail-page__tabs__tab" @click="selectedTab = 2">
              {{ $t("routovaciSkupiny") }}
            </div>
            <!--div class="detail-page__tabs__tab" @click="selectedTab = 3" v-bind:class="{'active':(selectedTab == 3)}">{{ $t("logOperaci") }}</div-->
            <RadioOpenClose
              :radio-slides="radioSlides"
              :show="showHelp"
              @update-show-radio-help="showRadioHelp($event)"
            />
          </div>
        </div>
        <div class="detail-page__tabs__content">
          <!-- VSE O ENDPOINTU -->
          <div v-if="selectedTab == 1">
            <div class="about">
              <div class="about__section">
                <div class="about__title">
                  <strong>
                    {{ $filters.firstUpper($t("informaceOZarizeni")) }}
                  </strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("NAZEV_BRANY")) }}
                    </div>
                    <div class="about__info__value">
                      {{ device.custDestName }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("idEndpoint")) }}
                    </div>
                    <div class="about__info__value">
                      {{ device.custDestId }}
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-center">
                    <div class="about__info__label gray-text-light">
                      {{ $filters.firstUpper($t("stav")) }}
                    </div>
                    <div class="about__info__value">
                      <div class="d-flex align-items-center">
                        <div v-if="device.custDestEnabled == true" class="d-flex align-items-center">
                          <div class="atom-state atom-state--success" />
                          {{ $filters.firstUpper($t("zapnutyEndpoint")) }}
                        </div>
                        <div v-else class="d-flex align-items-center">
                          <div class="atom-state atom-state--danger" />
                          {{ $filters.firstUpper($t("vypnutyEndpoint")) }}
                        </div>
                        {{ $filters.beforeTime(device.lastSuccessfulDelivery, "short") }}
                      </div>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("ROOT_TOPIC") }}
                    </div>
                    <div class="about__info__value">
                      <span
                        v-if="device.custDestParameters"
                        v-tooltip
                        :title="device.custDestParameters.address"
                        class="detail-page__info__item gray-text-light"
                      >
                        {{ $filters.strLimitEnd(device.custDestParameters.address, 36) }}
                        <div
                          v-if="device.custDestParameters.address"
                          class="atom-copy d-flex align-items-center ml-2"
                          @click="copyToClipboard(device.custDestParameters.address)"
                        >
                          <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                        </div>
                      </span>
                    </div>
                  </div>
                  <!--div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("popis") }}
                    </div>
                    <div class="about__info__value gray-text-light">
                     Je to na skříni v mezipatře
                    </div>
                  </div-->
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("routovaciSkupiny") }}
                    </div>
                    <div class="about__info__value d-flex flex-wrap">
                      <div v-for="(group, index) in device.deviceGroups" :key="group.deviceGroupId" class="mr-1">
                        <a
                          class="link-gray"
                          @click="
                            $router.push({
                              name: 'group',
                              params: { id: group.deviceGroupId, group: group }
                            })
                          "
                        >
                          <span>
                            {{ $filters.strLimit(group.deviceGroupName, 20) }}
                          </span>
                        </a>
                        <span v-if="index < device.deviceGroups.length - 1">,</span>
                      </div>
                    </div>
                  </div>
                  <!--div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("operacniSystem") }}
                    </div>
                    <div class="about__info__value">
                     DELL Windows server 2016
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("typServeru") }}
                    </div>
                    <div class="about__info__value">
                      VS
                    </div>
                  </div-->
                  <div v-if="device.tags" class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("tagy") }}
                    </div>
                    <div class="about__info__value">
                      <div v-for="tag in device.tags" :key="tag" class="">
                        <a class="atom-tag" href="#">
                          <span>{{ $filters.strLimit(tag, 11) }}</span>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("protokol") }}
                    </div>
                    <div class="about__info__value">MQTT</div>
                  </div>
                </div>
              </div>
              <div class="about__section">
                <div class="about__title">
                  <strong>{{ $t("zprávyZDoBrany") }}</strong>
                </div>
                <div class="about__info">
                  <div class="about__info__row d-flex align-items-start">
                    <div class="about__info__label gray-text-light">
                      {{ $t("posledniZpravaDoBrany") }}
                    </div>
                    <div class="about__info__value">
                      <div v-if="lastMessage > 0" class="detail-page__boxes__value d-flex align-items-center">
                        {{ $t("pred") }}{{ "\xa0" }}
                        <span v-if="lastMessage < 60">{{ lastMessage }} s</span>
                        <span v-else-if="lastMessage / 60 < 60">{{ Math.round(lastMessage / 60) }} m</span>
                        <span v-else-if="lastMessage / 60 / 60 < 24">{{ Math.round(lastMessage / 60 / 60) }} h</span>
                        <span v-else-if="lastMessage / 60 / 60 / 24 < 30">
                          {{ Math.round(lastMessage / 60 / 60 / 24) }} d
                        </span>
                        <span v-else>> 30 d</span>
                      </div>
                      <div v-else class="small" v-html="$t('zadnaAktivita')" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="about__section">
                <div class="about__title">
                  <strong>{{ $t("IdentifikacniUdaje") }}</strong>
                </div>
                <div class="about__info__row d-flex align-items-start">
                  <div class="about__info__label gray-text-light">
                    {{ $filters.firstUpper($t("mqttServer")) }}
                  </div>
                  <div class="about__info__value">mqtt.iot.cra.cz</div>
                </div>
                <div class="about__info__row d-flex align-items-start">
                  <div class="about__info__label gray-text-light">
                    {{ $filters.firstUpper($t("mqttPort")) }}
                  </div>
                  <div class="about__info__value">8883 SSL</div>
                </div>
                <div class="about__info__row d-flex align-items-start">
                  <div class="about__info__label gray-text-light">
                    {{ $filters.firstUpper($t("UZIVATELSKE_JMENO")) }}
                  </div>
                  <div class="about__info__value">
                    {{ $t("ZADANO_PRI_ZAKLADANI_MQTT_ZARIZENI") }}
                  </div>
                </div>
                <div class="about__info__row d-flex align-items-start">
                  <div class="about__info__label gray-text-light">
                    {{ $filters.firstUpper($t("HESLO")) }}
                  </div>
                  <div class="about__info__value">
                    {{ $t("ZADANO_PRI_ZAKLADANI_MQTT_ZARIZENI") }}
                  </div>
                </div>
              </div>
              <div class="about__section">
                <div class="about__title">
                  <strong>{{ $t("TOPIKY") }}</strong>
                </div>

                <div class="about__info__row d-flex align-items-start">
                  <div class="about__info__label gray-text-light">
                    {{ $filters.firstUpper($t("CTENI_Z_LORA")) }}
                  </div>
                  <div class="about__info__value">
                    <span class="detail-page__info__item">
                      subscribe
                      {{ device.custDestParameters.address }}.devices.lora.*.up
                      <div
                        v-if="device.custDestParameters.address"
                        class="atom-copy d-flex align-items-center ml-2"
                        @click="copyToClipboard(device.custDestParameters.address + '.devices.lora.*.up')"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                  </div>
                </div>
                <div class="about__info__row d-flex align-items-start">
                  <div class="about__info__label gray-text-light">
                    {{ $filters.firstUpper($t("ODESILANI_DO_LORA")) }}
                  </div>
                  <div class="about__info__value">
                    <span class="detail-page__info__item">
                      publish
                      {{ device.custDestParameters.address }}.devices.lora.*.down
                      <div
                        v-if="device.custDestParameters.address"
                        class="atom-copy d-flex align-items-center ml-2"
                        @click="copyToClipboard(device.custDestParameters.address + '.devices.lora.*.down')"
                      >
                        <img src="@/assets/icons/actions/ico-ico-copy.svg" />
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- ROUTOVACI SKUPUNY -->
          <div v-if="selectedTab == 2">
            <div v-if="groups">
              <div class="">
                <RoutingGroups
                  :customer-id="customerId"
                  :endpoint="device"
                  :full="false"
                  :groups="groups"
                  :project-id="projectId"
                  :selectable="false"
                  :selected-rows="selectedRows"
                  @search="searchGroups"
                  @clear-search="clearGroupsSearch"
                  @sort-by="sortRoutingGroupsBy"
                  @update-groups="loadDevice"
                />
              </div>
            </div>
          </div>
          <!-- ZPRAVY -->
          <div v-if="selectedTab == 3">
            <TableFilter :rows="allLogs" @filtered-items="filteredLogs" />
            <div>
              <span class="link">{{ $t("exportLogu") }}</span>
            </div>
            <div class="border-top mt-3 pb-3" />
            <div v-if="allLogs.length > 0" id="table-body" class="custom-table relative">
              <div class="custom-table__inner">
                <div :class="{ fixed: isTableHeaderFixed }" class="custom-table__header d-flex align-items-center">
                  <div class="custom-table__column code sortable px-2">
                    <div class="title" @click="sortBy('code')">
                      {{ $t("DESCRIPTION") }}
                    </div>
                    <div class="sorting">
                      <span v-if="sort == '%2Dcode'">▼</span>
                      <span v-if="sort == '%2Bcode'">▲</span>
                    </div>
                  </div>
                  <div class="custom-table__column d-none d-sm-flex level sortable px-2">
                    <div class="title" @click="sortBy('level')">
                      {{ $t("level") }}
                    </div>
                    <div class="sorting">
                      <span v-if="sort == '%2Dlevel'">▼</span>
                      <span v-if="sort == '%2Blevel'">▲</span>
                    </div>
                  </div>
                  <div class="custom-table__column d-none d-sm-flex timespamp sortable px-2">
                    <div class="title" @click="sortBy('timespamp')">
                      {{ $t("timespamp") }}
                    </div>
                    <div class="sorting">
                      <span v-if="sort == '%2Dtimespamp'">▼</span>
                      <span v-if="sort == '%2Btimespamp'">▲</span>
                    </div>
                  </div>
                  <div class="custom-table__column d-none d-md-flex user sortable px-2">
                    <div class="title" @click="sortBy('originator')">
                      {{ $t("originator") }}
                    </div>
                    <div class="sorting">
                      <span v-if="sort == '%2Doriginator'">▼</span>
                      <span v-if="sort == '%2Boriginator'">▲</span>
                    </div>
                  </div>
                  <div class="custom-table__column show sortable px-2" />
                </div>
                <div v-if="allLogs.length > 0" class="custom-table__content">
                  <div v-for="(log, index) in allLogs" :key="index" class="custom-table__row d-flex">
                    <div class="custom-table__column code px-2">
                      <span class="font-weight-bolder">{{ log.code }}</span>
                    </div>
                    <div class="custom-table__column d-none d-sm-flex level px-2">
                      <div v-if="log.level != ''" class="atom-tag m-0">
                        {{ log.level }}
                      </div>
                    </div>
                    <div class="custom-table__column d-none d-sm-flex timespamp px-2">
                      <span v-html="$filters.dateTime(log.timespamp)" />
                    </div>
                    <div class="custom-table__column d-none d-md-flex user px-2">
                      {{ log.parameters.userName }}
                    </div>
                    <div class="custom-table__column show px-2 justify-content-center text-center">
                      <span class="link">{{ $t("zobrazit") }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ShowMessage
      :device="device"
      :device-type="'endpoint'"
      :item="selectedMessage"
      :opened="openedMessageDetail"
      @close-box="toggleShowMessage"
    />
    <EditEndpointModal
      :opened="openedEditEndpoint"
      :original-endpoint="device"
      protocol="MQTT"
      @actualization-group-list="actualizationGroupList"
      @close-box="toggleEditEndpointModal"
      @open-box="toggleEditEndpointModal"
      @reload-items="loadDevice1"
    />
    <PingEndpointModal
      :centered="true"
      :items="pingResponses"
      :opened="openedPingEndpoint"
      @close="
        () => {
          openedPingEndpoint = false
          pingResponses = []
        }
      "
      @repeat="pingRepeat"
    />
    <DeleteEndpointModal
      :centered="true"
      :items="[device]"
      :opened="isDeleteModalOpen"
      :text="gatewayDetail.custDestName"
      @close="toggleDeleteModal()"
      @yes="
        () => {
          handleDeleteGateway()
          toggleDeleteModal()
        }
      "
    />
    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
  </div>
</template>

<script>
import _ from "lodash"
import axios from "axios"
import AppBack from "@/components/back.vue"
import RadioHelp from "@/components/radio/radio-help.vue"
import RadioOpenClose from "@/components/radio/radio-open-close.vue"
import TableFilter from "@/components/filters/log-table-filter.vue"
import RoutingGroups from "@/components/groups/groups.vue"
import EditEndpointModal from "@/components/modals/endpoints/edit.vue"
import PingEndpointModal from "@/components/confirmations/ping.vue"
import DeleteEndpointModal from "@/components/confirmations/delete.vue"
import ShowMessage from "@/components/modals/endpoints/messageShow.vue"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import CopyNotification from "@/components/notify/notify.vue"
import { useProjectStore } from "@/store/modules/project"
import { useConfigStore } from "@/store/modules/config"
import { useGatewaysStore } from "@/store/modules/gateways"

export default {
  components: {
    EditEndpointModal,
    AppBack,
    RadioHelp,
    RadioOpenClose,
    TableFilter,
    RoutingGroups,
    PingEndpointModal,
    DeleteEndpointModal,
    ShowMessage,
    ErrorModal,
    CopyNotification
  },
  props: {
    projectId: String,
    customerId: String
  },
  setup() {
    const projectStore = useProjectStore()
    const configStore = useConfigStore()
    const gatewaysStore = useGatewaysStore()

    return { projectStore, configStore, gatewaysStore }
  },
  data() {
    return {
      radioSlides: [],
      showHelp: true,
      deviceId: this.$route.params.id,
      device: this.$route.params.device,
      props: {
        device: Object
      },
      groups: [],
      endpoint: [],
      selectedRows: [],
      groupsEndpoints: [],
      openedDropdown: false,
      signal: 2,
      selectedTab: 1,
      service: {},
      sortGroups: "desc",
      openedGroups: [],
      openedGroup: {},
      openedGroupTags: [],
      isHeaderFixed: false,
      isTableHeaderFixed: false,
      openedMessageDetail: [],
      selectedMessage: {},
      copyConfirmVisible: false,
      allLogs: [
        {
          code: "Editace zařízení",
          level: "",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "karel.vochechule@email.muj",
          parameters: {
            userName: "Karel Vochechule"
          }
        },
        {
          code: "Konfigurační zpráva",
          level: "Ve frontě",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "jan.pavlasek@email.muj",
          parameters: {
            userName: "Jan Pavlásek"
          }
        },
        {
          code: "Vytvoření zařízení",
          level: "Ve frontě",
          timespamp: "2020-03-12T12:33:23.000Z",
          originator: "mirek@email.muj",
          parameters: {
            userName: "Mirek Dušín"
          }
        }
      ],
      allMessages: [],
      openedEditEndpoint: [],
      openedPingEndpoint: false,
      pingResponses: [],
      toDelete: [],
      isDeleteModalOpen: false,
      errorsToTranslate: [],
      openedError: false
    }
  },
  computed: {
    gatewayDetail() {
      return this.gatewaysStore.detail
    },
    isGatewayLoading() {
      return this.gatewaysStore.isLoading
    },
    id() {
      return this.$route.params.id
    },
    locale() {
      return this.$i18n.locale
    },
    project() {
      return this.projectStore.selectedProject
    },
    radioDisabled() {
      return this.configStore.isRadioHelpDisabled
    },
    lastMessage() {
      return Math.floor((new Date() - Date.parse(this.gatewayDetail.lastSuccessfulDelivery)) / 1000) || null
    }
  },
  watch: {
    locale() {
      this.loadSlides()
    },
    project() {
      if (this.device && this.project.projectId != this.device.projectId) {
        this.$router.push({
          name: "endpoints",
          params: {
            customerId: this.project.customerId,
            projectId: this.project.projectId
          }
        })
      }
    },
    radioDisabled: {
      handler() {
        this.showHelp = !this.radioDisabled
      },
      immediate: true
    }
  },
  async mounted() {
    await this.loadDevice()
    this.gatewaysStore.getGateway(this.id, true)

    const tabsElement = document.getElementById("tabs")
    window.document.onscroll = () => {
      if (tabsElement) {
        this.isHeaderFixed = window.scrollY > tabsElement.offsetTop + 250
      }
    }
  },
  unmounted() {
    window.document.onscroll = undefined
  },
  methods: {
    changeRadioBtnVisibility(radioSlides) {
      this.radioSlides = radioSlides
    },
    showRadioHelp(status) {
      this.showHelp = status
    },
    async loadDevice() {
      var id = this.$route.params.id
      await this.gatewaysStore.getGateway(id)
      this.device = this.gatewayDetail

      this.loadGroups(this.device)
      this.selectedRows = []
    },
    loadDevice1() {
      var id = this.$route.params.id
      axios
        .get(process.env.VUE_APP_API + "/mqtt/gateways/" + id, {})
        .then((result) => {
          this.device = result.data.data[0]
        })
        .catch(() => {})
    },
    loadGroups() {
      console.log("loadGroups() - after delete")
      this.selectedRows = []
      this.groups = []
      if (this.device.deviceGroups.length > 0) {
        for (var i = 0, len = this.device.deviceGroups.length; i < len; i++) {
          let group = this.device.deviceGroups[i]
          axios
            .get(process.env.VUE_APP_API + "/device-groups/" + group.deviceGroupId, {})
            .then((result) => {
              console.log("loadGroups - result", result)
              console.log(result)
              this.groups.push(result.data.data)
            })
            .catch(() => {})
        }
      }
    },
    sortBy(sortingParam) {
      let newSortingParam = ""
      this.selectedRows = []
      this.isSelectedAllOnPage = false
      if (this.sort.indexOf(sortingParam) > -1) {
        if (this.sort.substring(2, 3) == "D") {
          newSortingParam = "%2B" + sortingParam
        } else {
          newSortingParam = "%2D" + sortingParam
        }
      } else {
        newSortingParam = "%2D" + sortingParam
      }
      this.sort = newSortingParam
    },
    filteredLogs(logs) {
      this.allLogs = logs
    },
    copyToClipboard(text) {
      console.log("copy")
      this.copyConfirmVisible = true
      var input = document.createElement("textarea")
      input.innerHTML = text
      document.body.appendChild(input)
      input.select()
      var result = document.execCommand("copy")
      document.body.removeChild(input)
      return result
    },
    sortRoutingGroupsBy(sortBy) {
      let sorted
      if (this.sortGroups == "asc") {
        sorted = _.orderBy(this.groups, [(group) => group[sortBy].toString().toLowerCase()], ["desc"])
        this.sortGroups = "desc"
      } else {
        sorted = _.orderBy(this.groups, [(group) => group[sortBy].toString().toLowerCase()], ["asc"])
        this.sortGroups = "asc"
      }
      this.groups = sorted
    },
    searchGroups(search) {
      this.filterGroups(search)
    },
    filterGroups(search) {
      let filtered = this.groups.filter(
        (group) =>
          group.deviceGroupName.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
          group.deviceGroupDesc.toLowerCase().indexOf(search.toLowerCase()) !== -1
      )

      this.groups = filtered
    },
    clearGroupsSearch() {
      this.loadGroups()
    },
    onScroll() {},
    toggleEditEndpointModal(box) {
      if (this.openedEditEndpoint.indexOf(box) > -1) {
        box == undefined
          ? (this.openedEditEndpoint = [])
          : this.openedEditEndpoint.splice(this.openedEditEndpoint.indexOf(box), 1)
      } else {
        this.openedEditEndpoint.push(box)
      }
    },
    pingRepeat(item) {
      this.pingResponses.splice(this.pingResponses.indexOf(item), 1)
      this.ping(item)
    },
    ping(item) {
      let id = item.custDestId
      axios
        .get(process.env.VUE_APP_API + "/http/endpoints/" + id + "/ping", {
          /*
              }*/
        })
        .then((response) => {
          let obj = {
            endpoint: item,
            response: response.data.status
          }
          this.pingResponses.push(obj)
          this.openedPingEndpoint = true
        })
        .catch((response) => {
          let obj = {
            endpoint: item,
            response: "error",
            message: response.data.errors.join(",")
          }
          this.openedPingEndpoint = true
          this.pingResponses.push(obj)
        })
    },
    toggleDeleteModal() {
      this.isDeleteModalOpen = !this.isDeleteModalOpen
    },
    async handleDeleteGateway() {
      let id = this.device.custDestId
      let notifications = []
      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))
      try {
        await this.gatewaysStore.deleteGateway()
        this.$store.commit("modals/setWaitingLoader", "")
        notifications.push({
          text: "notificationEndpointDelete",
          error: false,
          params: {
            custDestId: id,
            custDestName: this.device.custDestName
          }
        })
        this.$router.push({
          name: "mqttEndpoints",
          params: {
            customerId: this.project.customerId,
            projectId: this.project.projectId,
            notifications: notifications
          }
        })
        this.openedError = true
      } catch (error) {
        this.$store.commit("modals/setWaitingLoader", "")
        let message = error.data.errors[0]
        error.data.errors = []
        error.data.errors.push({
          message: message,
          attribute: {
            custDestId: this.device.custDestId,
            custDestName: this.device.custDestName
          }
        })
        this.errorsToTranslate.push(error.data)
        this.openedError = true
      }
    },
    toggleShowMessage(box) {
      if (this.openedMessageDetail.indexOf(box) > -1) {
        box == undefined
          ? (this.openedMessageDetail = [])
          : this.openedMessageDetail.splice(this.openedMessageDetail.indexOf(box), 1)
      } else {
        this.openedMessageDetail.push(box)
      }
    },
    showMessage(message) {
      //console.log("message");
      //console.log(message);
      message.messageTime = message.requestTime
      this.selectedMessage = message
      this.openedMessageDetail.push("showMessage")
    },
    async actualizationGroupList() {
      this.selectedRows = []
      this.device.deviceGroups = []
      await this.loadDevice()
    }
  }
}
</script>

<style scoped></style>
